import { FC } from 'react';
import { Text } from 'components/_temp_ui_common/theme/Text';
import { Button } from 'components/core/button';
import HeadHYP2 from 'public/assets/img/buddies/Head-HYP-2.gif';
import PinkWink from 'public/assets/img/buddies/Pink-HYP-Wink-1X.gif';

import { LeadProgram, LeadProgramColor } from '../../constants';
import Links from '../Links';
import PhoneLink from '../PhoneLink';
import { Bullet } from './Bullet';

const SignUpConfirmationMedicaid: FC<{
  handleGoBack: () => void;
  program: LeadProgram;
}> = ({ handleGoBack, program }) => {
  return (
    <div className="flex mx-auto lg:w-[800px] w-full flex-col px-5 mb-10 lg:mb-0">
      <div className="flex items-center flex-col lg:flex-row">
        <div className="order-1 lg:order-last">
          {program === LeadProgram.ASP ? (
            <img
              src={PinkWink}
              className="h-28 w-28 lg:h-32 lg:w-36 rounded-full"
            />
          ) : (
            <img
              src={HeadHYP2}
              className="h-28 w-28 lg:h-32 lg:w-36 rounded-full"
              style={{
                backgroundColor: '#e6d5f1',
              }}
            />
          )}
        </div>
        <div className="flex flex-col w-full order-last lg:order-first lg:text-left mt-6 lg:mt-0">
          <Text
            variant="h3"
            style={{
              color: LeadProgramColor[program],
            }}
          >
            Thank you!
          </Text>
          <Text variant="body-2">
            We appreciate your interest in the Bend{' '}
            {program === LeadProgram.ASP
              ? 'Acute Stabilization'
              : 'Neuropsychological Evaluation'}{' '}
            Program.
          </Text>
        </div>
      </div>
      <div className="my-8">
        <Text variant="body-4">
          <Text variant="body-4" bold className="!inline">
            Unfortunately, we’re unable to accept Medicaid plans at this time.
          </Text>{' '}
          Your well-being matters to us. To ensure you receive the support you
          deserve, here are options available to consider:
        </Text>
        <div className="flex items-start gap-4 mt-4">
          <Bullet program={program}>
            <Text bold variant="body-4" className="m-0 p-0">
              01
            </Text>
          </Bullet>
          <Text variant="body-4" className="!inline">
            <Text variant="body-4" bold className="!inline">
              Bend offers out-of-pocket options
            </Text>{' '}
            or those who do not have access through their health insurance.
            Sliding scale and{' '}
            <Links
              url="https://www.carecredit.com/go/554PGK/"
              target="_blank"
              text="Care Credit"
              textVariant="body-4"
              bold
            />{' '}
            financing are available. Let us know if you’d like to explore
            self-pay.
          </Text>
        </div>
        <div className="flex items-start gap-4 mt-4">
          <Bullet program={program}>
            <Text bold variant="body-4" className="m-0 p-0">
              02
            </Text>
          </Bullet>
          <Text variant="body-4" className="!inline">
            <Text variant="body-4" bold className="!inline">
              Do you have an additional insurance provider?
            </Text>{' '}
            If so,{' '}
            <Links
              url="mailto:stabilization@bendhealth.com"
              target=""
              text="email photos of your alternative insurance cards"
              textVariant="body-4"
              bold
            />{' '}
            to have us check your eligibility.
          </Text>
        </div>
        <div className="flex items-start gap-4 mt-4">
          <Bullet program={program}>
            <Text bold variant="body-4" className="m-0 p-0">
              03
            </Text>
          </Bullet>
          <Text variant="body-4" className="!inline">
            <Text variant="body-4" bold className="!inline">
              Call the number on the back of your Medicaid card
            </Text>{' '}
            to find support services covered by Medicaid
          </Text>
        </div>
      </div>

      <div className="pt-8 relative before:absolute before:h-1 before:w-8 before:bg-[#ffafb4] before:top-0 pt-4 mt-8">
        <Text variant="body-4">
          <Links
            url="mailto:stabilization@bendhealth.com"
            target=""
            text="Email Us"
            textVariant="body-4"
            bold
          />{' '}
          us or call <PhoneLink phone="(800) 516-0975" target="" bold={true} />{' '}
          with questions or if you&apos;re interested in proceeding with another
          insurance provider or our out-of-pocket payment option
        </Text>
      </div>
      <div className="my-5 mx-auto">
        <Button className="" onClick={handleGoBack}>
          Create Another Request
        </Button>
      </div>
    </div>
  );
};

export default SignUpConfirmationMedicaid;
